import { RouterProvider } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/error-boundary';
import { AppProviders } from '@/providers/app-providers';
import { router } from '@/routes/router';

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
